import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import Index from "./pages/Index";
import Rodo from "./pages/Rodo";
import PolitykaPrywatnosci from "./pages/PolitykaPrywatnosci";
import Regulamin from "./pages/Regulamin";
import KabaretNaEventFirmowy from "./pages/seo/KabaretNaEventFirmowy";
import KabaretNaImprezeIntegracyjna from "./pages/seo/KabaretNaImprezeIntegracyjna";
import KabaretNaWesele from "./pages/seo/KabaretNaWesele";
import KabaretNaKonferencje from "./pages/seo/KabaretNaKonferencje";
import KabaretNaJubileusz from "./pages/seo/KabaretNaJubileusz";
import KabaretNaWigilieFirmowa from "./pages/seo/KabaretNaWigilieFirmowa";
import StandUpNaEvent from "./pages/seo/StandUpNaEvent";
import KabaretNaGale from "./pages/seo/KabaretNaGale";
import KomikNaEvent from "./pages/seo/KomikNaEvent";
import KabaretNaBankiet from "./pages/seo/KabaretNaBankiet";
import KabaretNaZamowienie from "./pages/seo/KabaretNaZamowienie";
import WystepKabaretowyWarszawa from "./pages/seo/WystepKabaretowyWarszawa";
import WystepKabaretowyKrakow from "./pages/seo/WystepKabaretowyKrakow";
import WystepKabaretowyWroclaw from "./pages/seo/WystepKabaretowyWroclaw";
import KabaretNaBalFirmowy from "./pages/seo/KabaretNaBalFirmowy";
import AtrakcjeNaEventFirmowy from "./pages/seo/AtrakcjeNaEventFirmowy";
import WystepKabaretowyPoznan from "./pages/seo/WystepKabaretowyPoznan";
import WystepKabaretowyGdansk from "./pages/seo/WystepKabaretowyGdansk";
import WystepKabaretowyKatowice from "./pages/seo/WystepKabaretowyKatowice";
import WystepKabaretowyLodz from "./pages/seo/WystepKabaretowyLodz";
import WystepKabaretowySzczecin from "./pages/seo/WystepKabaretowySzczecin";
import WystepKabaretowyLublin from "./pages/seo/WystepKabaretowyLublin";
import WystepKabaretowyBydgoszcz from "./pages/seo/WystepKabaretowyBydgoszcz";
import WystepKabaretowyBialystok from "./pages/seo/WystepKabaretowyBialystok";
import WystepKabaretowyRzeszow from "./pages/seo/WystepKabaretowyRzeszow";
import WystepKabaretowyKielce from "./pages/seo/WystepKabaretowyKielce";
import WystepKabaretowyOpole from "./pages/seo/WystepKabaretowyOpole";
import WystepKabaretowyOlsztyn from "./pages/seo/WystepKabaretowyOlsztyn";
import WystepKabaretowyZielonaGora from "./pages/seo/WystepKabaretowyZielonaGora";
import WystepKabaretowyTorun from "./pages/seo/WystepKabaretowyTorun";
import WystepKabaretowyCzestochowa from "./pages/seo/WystepKabaretowyCzestochowa";
import WystepKabaretowyRadom from "./pages/seo/WystepKabaretowyRadom";
import KabaretNaPiknikFirmowy from "./pages/seo/KabaretNaPiknikFirmowy";
import KabaretNaSylwestra from "./pages/seo/KabaretNaSylwestra";
import KabaretNaUrodzinyFirmy from "./pages/seo/KabaretNaUrodzinyFirmy";
import KabaretNaSpotkanieFirmowe from "./pages/seo/KabaretNaSpotkanieFirmowe";
import KabaretNaOtwarcieFirmy from "./pages/seo/KabaretNaOtwarcieFirmy";
import KabaretNaTargi from "./pages/seo/KabaretNaTargi";
import ProwadzenieImprezFirmowych from "./pages/seo/ProwadzenieImprezFirmowych";
import KabaretNaSzkolenie from "./pages/seo/KabaretNaSzkolenie";
import KabaretNaRoczniceFirmy from "./pages/seo/KabaretNaRoczniceFirmy";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/rodo" element={<Rodo />} />
          <Route path="/polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
          <Route path="/regulamin" element={<Regulamin />} />
          <Route path="/kabaret-na-event-firmowy" element={<KabaretNaEventFirmowy />} />
          <Route path="/kabaret-na-impreze-integracyjna" element={<KabaretNaImprezeIntegracyjna />} />
          <Route path="/kabaret-na-wesele" element={<KabaretNaWesele />} />
          <Route path="/kabaret-na-konferencje" element={<KabaretNaKonferencje />} />
          <Route path="/kabaret-na-jubileusz" element={<KabaretNaJubileusz />} />
          <Route path="/kabaret-na-wigilie-firmowa" element={<KabaretNaWigilieFirmowa />} />
          <Route path="/stand-up-na-event" element={<StandUpNaEvent />} />
          <Route path="/kabaret-na-gale" element={<KabaretNaGale />} />
          <Route path="/komik-na-event" element={<KomikNaEvent />} />
          <Route path="/kabaret-na-bankiet" element={<KabaretNaBankiet />} />
          <Route path="/kabaret-na-zamowienie" element={<KabaretNaZamowienie />} />
          <Route path="/wystep-kabaretowy-warszawa" element={<WystepKabaretowyWarszawa />} />
          <Route path="/wystep-kabaretowy-krakow" element={<WystepKabaretowyKrakow />} />
          <Route path="/wystep-kabaretowy-wroclaw" element={<WystepKabaretowyWroclaw />} />
          <Route path="/kabaret-na-bal-firmowy" element={<KabaretNaBalFirmowy />} />
          <Route path="/atrakcje-na-event-firmowy" element={<AtrakcjeNaEventFirmowy />} />
          <Route path="/wystep-kabaretowy-poznan" element={<WystepKabaretowyPoznan />} />
          <Route path="/wystep-kabaretowy-gdansk" element={<WystepKabaretowyGdansk />} />
          <Route path="/wystep-kabaretowy-katowice" element={<WystepKabaretowyKatowice />} />
          <Route path="/wystep-kabaretowy-lodz" element={<WystepKabaretowyLodz />} />
          <Route path="/wystep-kabaretowy-szczecin" element={<WystepKabaretowySzczecin />} />
          <Route path="/wystep-kabaretowy-lublin" element={<WystepKabaretowyLublin />} />
          <Route path="/wystep-kabaretowy-bydgoszcz" element={<WystepKabaretowyBydgoszcz />} />
          <Route path="/wystep-kabaretowy-bialystok" element={<WystepKabaretowyBialystok />} />
          <Route path="/wystep-kabaretowy-rzeszow" element={<WystepKabaretowyRzeszow />} />
          <Route path="/wystep-kabaretowy-kielce" element={<WystepKabaretowyKielce />} />
          <Route path="/wystep-kabaretowy-opole" element={<WystepKabaretowyOpole />} />
          <Route path="/wystep-kabaretowy-olsztyn" element={<WystepKabaretowyOlsztyn />} />
          <Route path="/wystep-kabaretowy-zielona-gora" element={<WystepKabaretowyZielonaGora />} />
          <Route path="/wystep-kabaretowy-torun" element={<WystepKabaretowyTorun />} />
          <Route path="/wystep-kabaretowy-czestochowa" element={<WystepKabaretowyCzestochowa />} />
          <Route path="/wystep-kabaretowy-radom" element={<WystepKabaretowyRadom />} />
          <Route path="/kabaret-na-piknik-firmowy" element={<KabaretNaPiknikFirmowy />} />
          <Route path="/kabaret-na-sylwestra" element={<KabaretNaSylwestra />} />
          <Route path="/kabaret-na-urodziny-firmy" element={<KabaretNaUrodzinyFirmy />} />
          <Route path="/kabaret-na-spotkanie-firmowe" element={<KabaretNaSpotkanieFirmowe />} />
          <Route path="/kabaret-na-otwarcie-firmy" element={<KabaretNaOtwarcieFirmy />} />
          <Route path="/kabaret-na-targi" element={<KabaretNaTargi />} />
          <Route path="/prowadzenie-imprez-firmowych" element={<ProwadzenieImprezFirmowych />} />
          <Route path="/kabaret-na-szkolenie" element={<KabaretNaSzkolenie />} />
          <Route path="/kabaret-na-rocznice-firmy" element={<KabaretNaRoczniceFirmy />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
